import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { BACKGROUND_IMAGE_ATTRIBUTE } from '../constants/block-background-attributes';
import getBackgroundImageSource from '../helpers/get-background-image-source';
import BlockSettingsContext from '../contexts/block-settings-context';
import BlockBackgroundImageContainer from './block-background-image-container';
import BlockSettingsOptionBox from '../components/block-settings-option-box';
import BlockSettingsOptionDivider from '../components/block-settings-option-divider';

const BlockBackgroundContainer = ({ withDivider = false }) => {
  const {
    options: { backgroundOption },
  } = useContext(BlockSettingsContext);

  if (!backgroundOption) return null;

  const { values, blockNode, checkVisibility } = backgroundOption;
  const mediaSrc = getBackgroundImageSource(blockNode) || values[BACKGROUND_IMAGE_ATTRIBUTE];

  if (!checkVisibility()) {
    return null;
  }

  return (
    <>
      <BlockSettingsOptionBox>
        <BlockBackgroundImageContainer mediaSrc={mediaSrc} blockNode={blockNode} />
      </BlockSettingsOptionBox>
      {withDivider && <BlockSettingsOptionDivider marginTop="spacing-s" />}
    </>
  );
};

BlockBackgroundContainer.propTypes = {
  withDivider: PropTypes.bool,
};

export default BlockBackgroundContainer;
